import {Component} from '@angular/core';
import {Skeleton} from 'primeng/skeleton';

@Component({
  selector: 'du-config-detail-skeleton',
  imports: [Skeleton],
  templateUrl: './config-detail-skeleton.component.html',
  styleUrl: './config-detail-skeleton.component.scss',
})
export class ConfigDetailSkeletonComponent {
  protected readonly Array = Array;
}
